import "./App.scss";
import Router from "./components/router/Router";
import './spinner.css'

const App = () => <Router />

export default App;
